module.exports = __webpack_public_path__ + "img/logo.a9e7eaf9.png";